const personInformationStrings = {
  title: "@:commonStrings.sender",
  nameLabel: "Navn",
  addressLabel: "Adresse",
  emailLabel: "E-postadresse",
  dateOfBirthLabel: "Fødselsdato"
};

export default personInformationStrings;